import React, {useState} from 'react';
import {Button, Input} from "reactstrap";
import {UserAccess} from "../../services/api/UserAccess";
import {apiErrorRaised, useApiErrorDispatch} from "../../context/api_error/ApiErrorIndex";
import {closeModal, openModal} from "../../context/modal/ModalActions";
import {useModalDispatch} from "../../context/modal/ModalContext";
import {useAuthState} from "../../context/auth/AuthIndex";

const UserAccessItem = ({access, setDeletedUserAccess}) => {
  const apiErrorDispatch = useApiErrorDispatch();
  const modalDispatch = useModalDispatch();
  const authState = useAuthState();
  const [userAccess, setUserAccess] = useState(access);

  // Handle role change for user access
  const handleRoleChange = (e) => {
    const newRole = e.target.value;
    UserAccess.put(userAccess.company_id, userAccess.id, {role: newRole}).then((r) => {
      if (r?.status < 400) {
        setUserAccess({...userAccess, role: newRole});
      } else {
        apiErrorRaised(apiErrorDispatch, r?.response);
      }
    });
  };

  // Handle delete user access
  const handleDeleteAccess = () => {
    openModal(modalDispatch, {
      title: 'Remove Company Access',
      message: `Are you sure you want to remove this user's access to ${userAccess.company_name}?`,
      onConfirm: () => {
        UserAccess.delete(userAccess.company_id, userAccess.id).then((r) => {
          if (r?.status < 400) {
            setDeletedUserAccess(true);
          } else {
            apiErrorRaised(apiErrorDispatch, r?.response);
          }
          closeModal(modalDispatch);
        });
      },
      onCancel: () => closeModal(modalDispatch),
      onBackdropClick: () => closeModal(modalDispatch),
      buttonColor: 'danger',
      buttonText: 'Remove',
      buttonIcon: 'fa-trash'
    });
  };

  return (
    <tr>
      <td>
        {userAccess.company_name || 'Unknown Company'}
      </td>
      <td>
        <Input
          type="select"
          name="role"
          value={userAccess.role}
          onChange={handleRoleChange}
          className="form-control"
        >
          {authState.user.role === 'admin' && <option value="owner">Owner</option>}
          <option value="admin">Admin</option>
          <option value="collaborator">Collaborator</option>
          <option value="viewer">Viewer</option>
        </Input>
      </td>
      <td className="text-right">
        <Button
          color="danger"
          outline
          className="btn-icon-only"
          onClick={handleDeleteAccess}
          title="Remove Access"
        >
          <span className="fa-solid fa-trash"/>
        </Button>
      </td>
    </tr>
  );
};

export default UserAccessItem;
